import { IBase } from '../base.interface';
import { IRole } from '@tickeat/permissions';
import { IShop } from '../shop.interface';

export interface IUser extends IBase {
  firstname: string;

  shops: Pick<IShop, '_id'>[];

  lastname: string;

  email: string;

  password: string;

  roles: (string | IRole)[];

  code: string;

  organization: string;

  phone: string;

  deletedAt: Date | null;
}
